<template>
  <table class="icm-tournament-structure icmttstrctr">
    <tr
      v-for="ii in options"
      :key="ii.name"
    >
      <td class="icmttstrctr_item_name">
        {{ ii.name }}
      </td>
      <td
        class="clr-white icmttstrctr_item_val"
        style="word-break: break-all"
      >
        {{ ii.val }}
      </td>
    </tr>
  </table>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'

export default {
  name: 'SolfigrIcmOtherStacksItem',
  mixins: [format_mix],
  props: {
    item: Object,
    icmTournament: Object,
  },
  computed: {
    options() {
      const conf = getSolfigrFields()
      const numOfPlayers =
        ((this.item.stacks_distribution_type === 'sdt_manual'
          ? this.item.stacks_manual
          : this.item.stacks_defined
        ).length || 0) + 2 // + 2 for IP, OOP
      return [
        {
          name: this.$t('solfigr.icm.num_of_players_remaining'),
          val: numOfPlayers,
        },
        this.item.lognormal_deviation !== null && {
          name: this.$t('solfigr.icm.avg_stack'),
          val: this.item.avg_stack,
        },
        conf.avg_bounty.is_active(this.icmTournament.type) && {
          name: this.$t('solfigr.icm.avg_bounty'),
          val: this.item.avg_bounty,
        },
      ].filter(Boolean)
    },
  },
}
</script>

<style lang="scss" scoped>
.icmttstrctr {
  &_item {
    display: flex;
    flex-direction: var(--icmttstrctr-item-flex-direction);
    gap: var(--icmttstrctr-item-gap);
    &_name {
      color: var(--clr-grey-2);
      padding: 0 1rem 0 0;
      vertical-align: top;
    }
    &_val {
      font-weight: 500;
      vertical-align: top;
    }
  }
}
</style>
